/* pp-sbs.js
   SIDE BY SIDE (Sept 2026, opened to every product Oct 1 2026). A shopper
   selects up to three pieces, from anywhere on the site, and we photograph
   and film them together. With one or two chosen they can ask the specialist
   to add a piece of their own choosing ("specialist's pick"), and every
   request says what they are deciding between (DECIDING).

   What this file does:
     - keeps the selection in localStorage (pp_sbs_v1) so it follows the
       shopper across pages and tabs, with an in-memory fallback when
       storage is blocked
     - syncs every [data-ppsbs-check] checkbox on the page
     - draws the tray at the bottom of the screen. On a product page not
       yet selected, its first empty slot is Add this.
       On pages where nothing can be added it shrinks to a pill.
     - draws the three slots on a product page ([data-ppsbs-pdp])
     - adds the one-line explainer above a collection grid
     - checks each selected piece is still for sale (/products/x.js) and
       marks it Sold if not, so nobody requests a piece that is gone
     - opens the request drawer (name, email and a required note, as on the
       single request since Sept 30 2026) and, when live, posts to the photo request
       Worker. While ppSbsConfig.live is false it sends NOTHING.

   Variants are the first available one. Clasp and length are chosen later
   on the private photo page, the same as a single request. */
(function () {
  'use strict';
  if (window.ppSbsLoaded) return;
  window.ppSbsLoaded = true;

  var CFG = window.ppSbsConfig || {};
  var MAX = CFG.max || 3;
  var KEY = 'pp_sbs_v1';
  var BACK = 'pp_sbs_back';
  var TTL = 30 * 24 * 3600 * 1000;
  var ROOT = (CFG.root || '/').replace(/\/?$/, '/');
  var WORDS = ['', 'one', 'two', 'three'];
  var DECIDING = ['Color', 'Size', 'Quality', 'Price', 'Style', 'Not sure'];

  var mem = [];
  var items = [];
  var soldMap = {};
  var shownAt = Date.now();

  /* ---------- storage ---------- */
  function valid(x) { return x && typeof x.h === 'string' && x.h && x.v; }
  function load() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var o = JSON.parse(raw);
      if (!o || !Array.isArray(o.items)) return [];
      if (o.t && Date.now() - o.t > TTL) return [];
      return o.items.filter(valid).slice(0, MAX);
    } catch (e) { return mem.slice(); }
  }
  function save() {
    mem = items.slice();
    try { window.localStorage.setItem(KEY, JSON.stringify({ v: 1, t: Date.now(), items: items })); } catch (e) {}
  }
  function getBack() { try { return window.localStorage.getItem(BACK) || ''; } catch (e) { return ''; } }
  function setBack(u) { try { window.localStorage.setItem(BACK, u); } catch (e) {} }

  /* ---------- model ---------- */
  function fromEl(el) {
    return {
      h: el.getAttribute('data-h'), pid: el.getAttribute('data-pid'), v: el.getAttribute('data-v'),
      t: el.getAttribute('data-t') || '', sku: el.getAttribute('data-sku') || '',
      p: el.getAttribute('data-p') || '', img: el.getAttribute('data-img') || '', u: el.getAttribute('data-u') || '',
      one: el.getAttribute('data-one') === '1'
    };
  }
  function idx(h) { for (var i = 0; i < items.length; i++) if (items[i].h === h) return i; return -1; }
  function has(h) { return idx(h) !== -1; }
  function add(it, front) {
    if (has(it.h)) return 'dup';
    if (items.length >= MAX) return 'full';
    if (front) items.unshift(it); else items.push(it);
    save(); return 'ok';
  }
  function remove(h) { var i = idx(h); if (i !== -1) { items.splice(i, 1); save(); } }
  function clearAll() { items = []; save(); }
  function isSold(h) { return soldMap[h] === true; }
  function live() { return items.filter(function (x) { return !isSold(x.h); }); }

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function pdpRoot() { return document.querySelector('[data-ppsbs-pdp]'); }
  function hint(msg, warn) {
    var hEl = tray && tray.querySelector('.ppsbs-tray__hint');
    if (!hEl) return;
    hEl.textContent = msg;
    hEl.classList.toggle('is-warn', !!warn);
    if (warn) {
      tray.classList.remove('is-nudge'); void tray.offsetWidth; tray.classList.add('is-nudge');
      clearTimeout(hint._t);
      hint._t = setTimeout(renderTray, 3800);
    }
  }
  var FULL_MSG = "You've chosen three. Remove one to add another.";

  /* ---------- checkboxes ---------- */
  function syncChecks() {
    var full = items.length >= MAX;
    var list = document.querySelectorAll('[data-ppsbs-check]');
    for (var i = 0; i < list.length; i++) {
      var lab = list[i], box = lab.querySelector('input');
      var on = has(lab.getAttribute('data-h'));
      if (box) { box.checked = on; box.setAttribute('aria-disabled', (!on && full) ? 'true' : 'false'); }
      lab.classList.toggle('is-on', on);
      lab.classList.toggle('is-locked', !on && full);
      lab.title = (!on && full) ? FULL_MSG : '';
    }
  }
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box.classList || !box.classList.contains('ppsbs-check__box')) return;
    var lab = box.closest('[data-ppsbs-check]');
    if (!lab) return;
    if (box.checked) {
      // Ticked in the strip under a product: the note there promises the
      // piece is photographed next to this one, so this one goes in first.
      var pdp = pdpRoot();
      if (pdp && lab.closest('#ppsbs-more') && !has(pdp.getAttribute('data-h')) && items.length < MAX - 1) {
        add(fromEl(pdp), true);
        pdp._folded = false;
      }
      var r = add(fromEl(lab));
      if (r === 'full') { box.checked = false; render(); hint(FULL_MSG, true); return; }
    } else {
      remove(lab.getAttribute('data-h'));
    }
    render();
    checkSold();
  });

  /* ---------- explainer ---------- */
  function explainer() {
    var t = CFG.pageType;
    if (t !== 'collection' && t !== 'search') return;
    var first = document.querySelector('[data-ppsbs-check]');
    if (!first || document.querySelector('.ppsbs-explain')) return;
    setBack(location.pathname + location.search);
    var grid = first.closest('.ppc__grid') || first.closest('.grid');
    if (!grid || !grid.parentNode) return;
        // Only where nearly every card can be added (sold-out cards have no checkbox). Elsewhere the checkboxes stand on their own.
    if (grid.querySelectorAll('[data-ppsbs-check]').length < grid.children.length * 0.8) return;
    var box = el('div', 'ppsbs-explain',
      '<p><b>Want to see a few together?</b> Choose up to three pieces, from anywhere on the site, ' +
      "and we'll photograph and film them side by side." +
      '<button type="button" class="ppsbs-link" data-ppsbs-how>How it works</button></p>');
    grid.parentNode.insertBefore(box, grid);
  }

  /* ---------- where "+ add" goes ---------- */
  function goFind() {
    var strip = document.getElementById('ppsbs-more');
    var first = document.querySelector('[data-ppsbs-check]');
    var target = strip || (first && (first.closest('.ppc__grid') || first.closest('.grid')));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var pdp = pdpRoot();
    var dest = getBack() || (pdp && pdp.getAttribute('data-browse')) || '';
    if (dest) window.location.href = dest;
  }

  /* ---------- tray ---------- */
  var tray = null;
  function buildTray() {
    tray = el('div', 'ppsbs-tray');
    tray.setAttribute('role', 'region');
    tray.setAttribute('aria-label', 'Pieces selected to see side by side');
    tray.innerHTML =
      '<div class="ppsbs-tray__in">' +
        '<div class="ppsbs-tray__slots"></div>' +
        '<div class="ppsbs-tray__meta">' +
          '<p class="ppsbs-tray__count" aria-live="polite"></p>' +
          '<p class="ppsbs-tray__hint"></p>' +
          '<button type="button" class="ppsbs-tray__clear" data-ppsbs-clear>Clear</button>' +
        '</div>' +
        '<button type="button" class="ppsbs-btn" data-ppsbs-open>See side by side</button>' +
      '</div>';
    document.body.appendChild(tray);
  }
  function slotHtml(it) {
    var sold = isSold(it.h);
    return '<div class="ppsbs-slot' + (sold ? ' is-sold' : '') + '">' +
      '<a href="' + esc(it.u) + '" title="' + esc(it.t) + '"><img src="' + esc(it.img) + '" alt="' + esc(it.t) + '" loading="lazy"></a>' +
      (sold ? '<span class="ppsbs-sold">Sold</span>' : '') +
      '<button type="button" class="ppsbs-slot__x" data-ppsbs-rm="' + esc(it.h) + '" aria-label="Remove ' + esc(it.t) + '">&times;</button>' +
      '</div>';
  }
  function renderTray() {
    if (!tray) buildTray();
    var n = items.length;
    // On a product page that is not in the selection yet, the
    // first empty slot adds the piece being viewed (Jeremy, Sept 30 2026).
    // It shows that piece faded behind the +, so it is clear what a tap does.
    var pdp = pdpRoot();
    var here = pdp && !has(pdp.getAttribute('data-h')) && n < MAX ? fromEl(pdp) : null;
    var slots = '';
    for (var i = 0; i < MAX; i++) {
      if (items[i]) { slots += slotHtml(items[i]); continue; }
      if (here && i === n) {
        slots += '<button type="button" class="ppsbs-slot ppsbs-slot--here" data-ppsbs-addhere aria-label="Add ' + esc(here.t) + '">' +
          (here.img ? '<img src="' + esc(here.img) + '" alt="">' : '') + '<span><i>+</i>Add this</span></button>';
        continue;
      }
      slots += '<button type="button" class="ppsbs-slot ppsbs-slot--empty" data-ppsbs-find aria-label="Add a piece">+</button>';
    }
    tray.querySelector('.ppsbs-tray__slots').innerHTML = slots;
    tray.querySelector('.ppsbs-tray__count').textContent = n + ' of ' + MAX + ' selected';
    var ok = live().length;
    var soldN = n - ok;
    var msg;
    if (soldN) msg = (soldN === 1 ? 'One piece has' : 'Some pieces have') + ' sold. Remove it to choose another.';
    else if (here) msg = 'Tap Add this to include the piece you are viewing.';
    else if (ok < 2) msg = 'Choose one more to compare, or let your specialist suggest one.';
    else if (ok < MAX) msg = 'Add one more, or see these ' + WORDS[ok] + ' now.';
    else msg = "We'll photograph these three together.";
    var hEl = tray.querySelector('.ppsbs-tray__hint');
    hEl.textContent = msg; hEl.classList.toggle('is-warn', !!soldN);
    var tb = tray.querySelector('[data-ppsbs-open]');
    tb.disabled = ok < 1;
    tb.textContent = ok < 2 ? 'Ask for a suggestion' : 'See side by side';
    // Pages where nothing can be added (a stocked pendant, the cart, a blog
    // post) get the small pill instead of the full tray. See renderPill.
    var full = eligiblePage();
    var show = n > 0 && full;
    tray.classList.toggle('is-on', show);
    document.body.classList.toggle('ppsbs-has-tray', show);
    renderPill(n > 0 && !full);
  }

  /* ---------- pill (Sept 30 2026) ----------
     On a page where nothing can be added (the cart, a blog post, a sold-out
     piece), the full tray with its empty + slots promised something the page
     could not do. The pill keeps the selection in view, opens to show it, and
     points back to where more can be chosen.

     A page can add when it is a product page still for sale (it has the
     side by side rows), or a collection or search page with at least one
     See side by side checkbox. Since Oct 1 2026 that is any product, not only
     one-of-a-kind pieces. */
  function eligiblePage() {
    if (pdpRoot()) return true;
    var t = CFG.pageType;
    return (t === 'collection' || t === 'search') && !!document.querySelector('[data-ppsbs-check]');
  }
  var pill = null;
  function buildPill() {
    pill = el('div', 'ppsbs-pill');
    pill.hidden = true;
    pill.innerHTML =
      '<div class="ppsbs-pill__pop" id="ppsbs-pill-pop" hidden>' +
        '<div class="ppsbs-pill__head"><b>Side by side</b>' +
          '<button type="button" class="ppsbs-pill__x" data-ppsbs-pill-close aria-label="Close">&times;</button></div>' +
        '<div class="ppsbs-pill__slots"></div>' +
        '<p class="ppsbs-pill__note">Compare any pieces on the site, photographed and filmed together.</p>' +
        '<div class="ppsbs-pill__acts">' +
          '<button type="button" class="ppsbs-btn" data-ppsbs-open>See side by side</button>' +
          '<div class="ppsbs-pill__more"><span>Keep browsing</span>' +
            '<a class="ppsbs-pill__browse" href="/collections/akoya-pearls">akoya</a>' +
            '<a class="ppsbs-pill__browse" href="/collections/tahitian-pearls">Tahitian</a>' +
            '<a class="ppsbs-pill__browse" href="/collections/south-sea-pearls">South Sea</a>' +
            '<a class="ppsbs-pill__browse" href="/collections/freshwater-pearls">Freshwater</a>' +
            '<a class="ppsbs-pill__browse" href="/collections/the-vault-collection">The Vault</a></div>' +
          '<button type="button" class="ppsbs-tray__clear" data-ppsbs-clear>Clear</button>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="ppsbs-pill__btn" data-ppsbs-pill aria-expanded="false" aria-controls="ppsbs-pill-pop">' +
        '<span class="ppsbs-pill__pics"></span><span class="ppsbs-pill__txt"></span><i aria-hidden="true"></i>' +
      '</button>';
    document.body.appendChild(pill);
  }
  function renderPill(show) {
    if (!show) { if (pill) { pill.hidden = true; pillOpen(false); } return; }
    if (!pill) buildPill();
    var n = items.length, ok = live().length, pics = '', slots = '';
    for (var i = 0; i < n; i++) {
      var it = items[i];
      pics += '<img src="' + esc(it.img) + '" alt=""' + (isSold(it.h) ? ' class="is-sold"' : '') + '>';
      slots += slotHtml(it);
    }
    pill.querySelector('.ppsbs-pill__pics').innerHTML = pics;
    pill.querySelector('.ppsbs-pill__txt').textContent = 'Side by side · ' + n + ' selected';
    pill.querySelector('.ppsbs-pill__slots').innerHTML = slots;
    var go = pill.querySelector('[data-ppsbs-open]');
    go.disabled = ok < 1;
    go.textContent = ok < 2 ? 'Ask your specialist to suggest one' : 'See these ' + WORDS[ok] + ' side by side';
    pill.hidden = false;
  }
  function pillOpen(open) {
    if (!pill) return;
    var pop = pill.querySelector('.ppsbs-pill__pop');
    pop.hidden = !open;
    pill.querySelector('[data-ppsbs-pill]').setAttribute('aria-expanded', open ? 'true' : 'false');
    pill.classList.toggle('is-open', open);
  }
  document.addEventListener('click', function (e) {
    if (!pill || pill.hidden) return;
    var t = e.target;
    if (t.closest && t.closest('[data-ppsbs-pill]')) {
      pillOpen(pill.querySelector('.ppsbs-pill__pop').hidden); return;
    }
    if (t.closest && t.closest('[data-ppsbs-pill-close]')) { pillOpen(false); return; }
    if (t.closest && t.closest('[data-ppsbs-open]')) { pillOpen(false); return; }
    // A remove button inside the pill is re-rendered before this runs, so
    // its target is detached by now. That is not an outside click.
    if (!document.documentElement.contains(t)) return;
    if (!pill.contains(t)) pillOpen(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && pill && !pill.hidden) pillOpen(false);
  });

  /* ---------- product page slots ---------- */
  function renderPdp() {
    var root = pdpRoot();
    if (!root) return;
    var me = root.getAttribute('data-h');
    var noun = root.getAttribute('data-noun') || 'piece';
    var panel = root.querySelector('[data-ppsbs-pdp-panel]');
    var btn = root.querySelector('[data-ppsbs-pdp-open]');
    var mine = has(me);
    // Open while this piece is in the selection, unless the shopper folded
    // it away with the button. Taking it out of the selection closes it.
    if (!mine) { panel.hidden = true; root._folded = false; }
    else panel.hidden = !!root._folded;
    btn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
    if (panel.hidden) return;

    var meItem = items[idx(me)] || fromEl(root);
    var others = items.filter(function (x) { return x.h !== me; });
    var html = '<div class="ppsbs-pdp__slots">';
    html += '<div class="ppsbs-pslot"><span class="ppsbs-pslot__pic"><img src="' + esc(meItem.img) + '" alt=""></span>' +
      '<span class="ppsbs-pslot__k">This ' + esc(noun) + '</span>' +
      '<span class="ppsbs-pslot__p">' + esc(meItem.p) + '</span>' +
      '<button type="button" class="ppsbs-pslot__rm" data-ppsbs-rm="' + esc(me) + '">Remove</button></div>';
    for (var i = 0; i < MAX - 1; i++) {
      var o = others[i];
      if (o) {
        var sold = isSold(o.h);
        html += '<div class="ppsbs-pslot' + (sold ? ' is-sold' : '') + '"><a class="ppsbs-pslot__pic" href="' + esc(o.u) + '" title="' + esc(o.t) + '"><img src="' + esc(o.img) + '" alt="' + esc(o.t) + '">' +
          (sold ? '<span class="ppsbs-sold">Sold</span>' : '') + '</a>' +
          '<span class="ppsbs-pslot__p">' + esc(o.p) + '</span>' +
          '<button type="button" class="ppsbs-pslot__rm" data-ppsbs-rm="' + esc(o.h) + '">Remove</button></div>';
      } else {
        html += '<div class="ppsbs-pslot ppsbs-pslot--empty"><span class="ppsbs-pslot__pic">' +
          '<button type="button" class="ppsbs-pslot__add" data-ppsbs-find><i>+</i>Add a ' + esc(noun === 'strand' ? 'strand' : 'piece') + '</button></span></div>';
      }
    }
    html += '</div>';
    var ok = live().length;
    html += '<div class="ppsbs-pdp__foot"><button type="button" class="ppsbs-btn" data-ppsbs-open' + (ok < 1 ? ' disabled' : '') + '>' +
      (ok < 2 ? 'Ask your specialist to suggest one' : 'See these ' + WORDS[ok] + ' side by side') + '</button>' +
      '<p class="ppsbs-pdp__note">Add pieces from below or from anywhere on the site, or let your specialist choose one to show beside it. Your selection stays with you as you browse.</p></div>';
    panel.innerHTML = html;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ppsbs-pdp-open]');
    if (!b) return;
    var root = pdpRoot();
    var me = root.getAttribute('data-h');
    if (has(me)) { root._folded = !root._folded; render(); return; }
    var r = add(fromEl(root), true);
    root._folded = false;
    render();
    if (r === 'full') hint("You've chosen three already. Remove one to add this " + (root.getAttribute('data-noun') || 'piece') + '.', true);
    checkSold();
  });

  /* ---------- drawer ---------- */
  var dlg = null, opener = null;
  function buildDlg() {
    dlg = el('div', 'ppsbs-dlg');
    dlg.hidden = true;
    dlg.setAttribute('role', 'dialog');
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('aria-labelledby', 'ppsbs-dlg-h');
    dlg.innerHTML = '<div class="ppsbs-dlg__scrim" data-ppsbs-close></div>' +
      '<div class="ppsbs-dlg__panel"><button type="button" class="ppsbs-dlg__x" data-ppsbs-close aria-label="Close">&times;</button>' +
      '<div class="ppsbs-dlg__body"></div></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDlg(); return; }
      if (e.key !== 'Tab') return;
      var f = dlg.querySelectorAll('a[href],button:not([disabled]),input:not(.ppsbs-hp),textarea');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
  }
  function openDlg(mode, from) {
    if (!dlg) buildDlg();
    opener = from || document.activeElement;
    dlg._mode = mode;
    dlg._sent = false;
    drawDlg();
    dlg.hidden = false;
    document.documentElement.classList.add('ppsbs-lock');
    var f = dlg.querySelector(mode === 'how' ? '.ppsbs-dlg__x' : 'input[name="name"]') || dlg.querySelector('.ppsbs-dlg__x');
    setTimeout(function () { try { f.focus(); } catch (e) {} }, 30);
  }
  function closeDlg() {
    if (!dlg || dlg.hidden) return;
    dlg.hidden = true;
    document.documentElement.classList.remove('ppsbs-lock');
    if (opener && opener.focus) { try { opener.focus(); } catch (e) {} }
  }
  function howHtml() {
    return '<p class="ppsbs-eyebrow">Side by side</p><h2 class="ppsbs-dlg__h" id="ppsbs-dlg-h">How it works</h2>' +
      '<ol class="ppsbs-steps">' +
      '<li>Choose up to three pieces from anywhere on the site. Only have one or two in mind? Your specialist can add one they think is worth seeing next to yours.</li>' +
      '<li>We lay them side by side under the same light, photograph them together and film one comparison video.</li>' +
      '<li>You get a private page with the photos, the video and a buy button for each piece, usually within one business day.</li>' +
      '</ol>' +
      '<p class="ppsbs-fine">' + holdLine(items) + '</p>' +
      '<p style="margin:20px 0 0"><button type="button" class="ppsbs-btn" data-ppsbs-close>Got it</button></p>';
  }
  function reqHtml() {
    var ok = live().length;
    var list = '';
    if (!dlg) buildDlg();
    for (var i = 0; i < items.length; i++) {
      var it = items[i], sold = isSold(it.h);
      list += '<li class="ppsbs-dlg__item' + (sold ? ' is-sold' : '') + '">' +
        '<span class="ppsbs-dlg__pic"><img src="' + esc(it.img) + '" alt="">' + (sold ? '<span class="ppsbs-sold">Sold</span>' : '') + '</span>' +
        '<span class="ppsbs-dlg__txt"><p class="ppsbs-dlg__t"><a href="' + esc(it.u) + '">' + esc(it.t) + '</a></p>' +
        '<p class="ppsbs-dlg__m">' + (it.sku ? esc(it.sku) + ' · ' : '') + (sold ? 'Sold' : esc(it.p)) + '</p></span>' +
        '<button type="button" class="ppsbs-dlg__rm" data-ppsbs-rm="' + esc(it.h) + '">Remove</button></li>';
    }
    var pickForced = ok === 1;
    var pickOn = pickForced || !!dlg._pick;
    var canPick = ok < MAX;
    var head = ok >= 2 ? "We'll photograph these " + WORDS[ok] + ' together' + (pickOn && canPick ? ', plus our pick' : '') :
      (ok === 1 ? "We'll photograph this beside a piece we choose for you" : 'Choose a piece first');
    var chips = '';
    for (var di = 0; di < DECIDING.length; di++) {
      chips += '<label class="ppsbs-q__c"><input type="radio" name="deciding" value="' + DECIDING[di] + '"' + (dlg._deciding === DECIDING[di] ? ' checked' : '') + '><span>' + DECIDING[di] + '</span></label>';
    }
    return '<p class="ppsbs-eyebrow">Side by side</p><h2 class="ppsbs-dlg__h" id="ppsbs-dlg-h">' + head + '</h2>' +
      "<p class=\"ppsbs-dlg__lede\">Photographed together, under the same light, with one comparison video. You'll get a private page with everything and a buy button for each, usually within one business day.</p>" +
      '<ul class="ppsbs-dlg__list">' + list + '</ul>' +
      (ok < items.length ? '<p class="ppsbs-err">A piece you selected has sold. Remove it, or send the request for the others.</p>' : '') +
      '<form class="ppsbs-form" novalidate>' +
        '<label class="ppsbs-field"><span>Your name</span><input type="text" name="name" required maxlength="80" autocomplete="name" placeholder="First and last name"></label>' +
        '<label class="ppsbs-field"><span>Your email address</span><input type="email" name="email" required autocomplete="email" placeholder="you@example.com"></label>' +
        '<fieldset class="ppsbs-q"><legend>What matters most to you?</legend><div class="ppsbs-q__row">' + chips + '</div></fieldset>' +
        '<label class="ppsbs-pick' + (canPick ? '' : ' is-off') + '"><input type="checkbox" name="pick"' + (pickOn && canPick ? ' checked' : '') + (pickForced || !canPick ? ' disabled' : '') + '>' +
          '<span><b>Let my specialist add a piece</b> ' + (canPick ? (pickForced ? 'With one piece selected, your specialist will add another worth comparing, so you can see them side by side.' : 'One they think is worth comparing with yours.') : 'Remove one of your three to make room for a suggestion.') + '</span></label>' +
        '<label class="ppsbs-field"><span>What would you like your specialist to know?</span><textarea name="note" rows="3" minlength="10" maxlength="600" required placeholder="For example: It\'s a gift for my wife. I love the color of the first one, but I\'m not sure the larger pearls are worth the difference."></textarea>' +
        '<em class="ppsbs-hint">A line or two is plenty. Your specialist reads it before filming and replies with your photos.</em></label>' +
        '<input class="ppsbs-hp" type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '<p class="ppsbs-err" data-ppsbs-err hidden></p>' +
        '<button type="submit" class="ppsbs-btn"' + (ok < 1 ? ' disabled' : '') + '>Send my request</button>' +
        '<p class="ppsbs-fine">' + holdLine(live()) + ' We usually reply within one business day, Monday through Friday.</p>' +
      '</form>';
  }
  function doneHtml(res, preview) {
    var n = WORDS[(res && res.count) || live().length] || '';
    return '<p class="ppsbs-eyebrow">Side by side</p><h2 class="ppsbs-dlg__h" id="ppsbs-dlg-h">Thank you</h2>' +
      '<div class="ppsbs-done"><b>We have your request' + (res && res.request_number ? ', ' + esc(res.request_number) : '') + '.</b> ' +
      "We'll photograph the " + n + ' pieces together' + (res && res.pick ? ', including one your specialist chooses,' : '') + ' and email you a link to your private page, usually within one business day.</div>' +
      (preview ? '<p class="ppsbs-preview">Preview build. This request was not sent anywhere.</p>' : '') +
      '<p style="margin:20px 0 0"><button type="button" class="ppsbs-btn" data-ppsbs-close>Close</button></p>';
  }
  // What is held depends on what was chosen: stocked pieces are held 48
  // hours once the photos go out, one-of-a-kind pieces never are.
  function holdLine(list) {
    var one = 0, stock = 0;
    for (var i = 0; i < list.length; i++) { if (list[i].one) one++; else stock++; }
    if (one && !stock) return "One-of-a-kind pieces aren't held, so another customer may buy one while you decide. If one sells, your page will show it as sold. Your page stays open for two weeks.";
    if (!one && !stock) return "Stocked pieces are held for 48 hours once we send your photos. One-of-a-kind pieces stay available until they sell. Your page stays open for two weeks.";
    if (one && stock) return "We hold the stocked pieces for 48 hours once we send your photos. One-of-a-kind pieces aren't held, so if one sells while you decide, your page will show it as sold. Your page stays open for two weeks.";
    return 'We hold the pieces we photograph for you for 48 hours once we send your photos. Your page stays open for two weeks.';
  }
  function drawDlg() {
    if (!dlg || dlg._sent) return;
    var body = dlg.querySelector('.ppsbs-dlg__body');
    var keep = {};
    var form = body.querySelector('form');
    if (form) {
      keep.name = form.elements['name'].value; keep.email = form.elements['email'].value; keep.note = form.elements['note'].value;
      var dc = form.querySelector('input[name="deciding"]:checked'); if (dc) dlg._deciding = dc.value;
      var pk = form.elements['pick']; if (pk && !pk.disabled) dlg._pick = pk.checked;
    }
    body.innerHTML = dlg._mode === 'how' ? howHtml() : reqHtml();
    form = body.querySelector('form');
    if (form) {
      if (keep.name) form.elements['name'].value = keep.name;
      if (keep.email) form.elements['email'].value = keep.email;
      if (keep.note) form.elements['note'].value = keep.note;
      form.addEventListener('submit', submit);
      form.addEventListener('change', function (e) {
        if (e.target.name === 'deciding') { dlg._deciding = e.target.value; var qq = form.querySelector('.ppsbs-q'); if (qq) qq.classList.remove('is-bad'); }
        if (e.target.name === 'pick') { dlg._pick = e.target.checked; drawDlg(); }
      });
    }
  }

  /* ---------- submit ---------- */
  var busy = false;
  function submit(e) {
    e.preventDefault();
    if (busy) return;
    var f = e.target;
    var err = f.querySelector('[data-ppsbs-err]');
    var name = f.elements['name'].value.trim(), email = f.elements['email'].value.trim(), note = f.elements['note'].value.trim();
    var bad = null;
    var fName = f.elements['name'], fEmail = f.elements['email'];
    var fNote = f.elements['note'];
    if (!name) bad = fName;
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) bad = fEmail;
    else if (note.length < 10) bad = fNote;
    var fields = f.querySelectorAll('.ppsbs-field');
    for (var i = 0; i < fields.length; i++) fields[i].classList.remove('is-bad');
    if (bad) {
      bad.closest('.ppsbs-field').classList.add('is-bad');
      err.textContent = bad === fName ? 'Please add your name.' : bad === fEmail ? 'Please check your email address.' :
        'Please add a short note for your specialist, even a single line.';
      err.hidden = false; bad.focus(); return;
    }
    var picks = live();
    var dc = f.querySelector('input[name="deciding"]:checked');
    var pickBox = f.elements['pick'];
    var wantPick = picks.length === 1 || !!(pickBox && pickBox.checked && !pickBox.disabled);
    if (picks.length >= MAX) wantPick = false;
    if (picks.length < 1) { err.textContent = 'Choose at least one piece that is still available.'; err.hidden = false; return; }
    if (!dc) {
      var q = f.querySelector('.ppsbs-q'); if (q) q.classList.add('is-bad');
      err.textContent = "Tell us what matters most. One tap is enough."; err.hidden = false;
      var firstChip = f.querySelector('input[name="deciding"]'); if (firstChip) firstChip.focus(); return;
    }
    err.hidden = true;

    var payload = {
      kind: 'side_by_side',
      name: name, email: email, note: note,
      deciding: dc.value,
      specialist_pick: wantPick,
      items: picks.map(function (x) { return { variant_id: x.v, product_id: x.pid, handle: x.h }; }),
      variant_id: picks[0].v,
      url: window.location.origin + window.location.pathname,
      hp: f.elements['website'].value,
      ms: Date.now() - shownAt
    };

    if (!CFG.live || !CFG.endpoint || !window.fetch) {
      if (window.console) console.info('[pp-sbs] preview, not sent', payload);
      finish({ count: picks.length + (wantPick ? 1 : 0), pick: wantPick }, true);
      return;
    }
    busy = true;
    var btn = f.querySelector('button[type="submit"]');
    btn.disabled = true; btn.textContent = 'Sending';
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 10000);
    fetch(CFG.endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) { return r.json().catch(function () { return null; }); })
      .catch(function () { return null; })
      .then(function (res) {
        clearTimeout(timer); busy = false;
        if (res && res.error === 'sold' && res.sold && res.sold.length) {
          // A piece sold while they were choosing. Mark it and let them
          // send the rest, or pick another.
          res.sold.forEach(function (h) { soldMap[h] = true; });
          render();
          var e2 = dlg.querySelector('[data-ppsbs-err]');
          if (e2) { e2.textContent = 'One of these pieces has just sold. Remove it, or add another, and send again.'; e2.hidden = false; }
          return;
        }
        if (!res || !res.ok) {
          btn.disabled = false; btn.textContent = 'Send my request';
          err.textContent = "Something went wrong on our side. Please try again, or email us and we'll set it up for you.";
          err.hidden = false; return;
        }
        res.count = picks.length + (wantPick ? 1 : 0);
        res.pick = wantPick;
                if (res.request_number) { try { if (window.gtag) window.gtag('event', 'side_by_side_request', { request_number: res.request_number, piece_count: res.count, deciding: dc.value, specialist_pick: wantPick }); } catch (e) {} }
        clearAll();
        finish(res, false);
        render();
      });
  }
  function finish(res, preview) {
    dlg._sent = true;
    dlg.querySelector('.ppsbs-dlg__body').innerHTML = doneHtml(res, preview);
    var c = dlg.querySelector('.ppsbs-dlg__body [data-ppsbs-close]');
    if (c) c.focus();
  }

  /* ---------- sold checks ---------- */
  var checked = {};
  function checkSold() {
    items.forEach(function (it) {
      if (checked[it.h]) return;
      checked[it.h] = true;
      if (!window.fetch) return;
      fetch(ROOT + 'products/' + encodeURIComponent(it.h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.status === 404 ? { available: false } : (r.ok ? r.json() : null); })
        .then(function (p) {
          if (!p) return;
          var was = soldMap[it.h];
          soldMap[it.h] = p.available === false;
          if (was !== soldMap[it.h]) render();
        }).catch(function () {});
    });
  }

  /* ---------- shared clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var rm = t.closest('[data-ppsbs-rm]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-ppsbs-rm')); render(); return; }
    if (t.closest('[data-ppsbs-clear]')) { clearAll(); render(); return; }
    if (t.closest('[data-ppsbs-find]')) { goFind(); return; }
    if (t.closest('[data-ppsbs-addhere]')) {
      var pr = pdpRoot();
      if (pr && add(fromEl(pr)) === 'ok') { pr._folded = false; render(); checkSold(); }
      return;
    }
    var op = t.closest('[data-ppsbs-open]');
    if (op && !op.disabled) { openDlg('req', op); return; }
    var how = t.closest('[data-ppsbs-how]');
    if (how) { openDlg('how', how); return; }
    if (t.closest('[data-ppsbs-close]')) { closeDlg(); return; }
  });

  /* ---------- render ---------- */
  function render() {
    syncChecks();
    renderTray();
    renderPdp();
    if (dlg && !dlg.hidden && dlg._mode === 'req') drawDlg();
  }
  function refresh() { items = load(); render(); checkSold(); }

  function init() {
    items = load();
    explainer();
    render();
    checkSold();
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.ppSbs = { items: function () { return items.slice(); }, clear: function () { clearAll(); render(); } };
})();
